import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop";

// Context Providers
import { GlobalProvider } from "./context/GlobalContext";
import { AuthProvider } from "./context/AuthContext";

// Layout Components
import Header from "./components/Header";
import Footer from "./components/Footer";

// Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import MobilityImagingPage from "./pages/MobilityImagingPage";
import SurveillancePage from "./pages/SurveillancePage";
import UltrasonicPage from "./pages/UltrasonicPage";
import EngineeringPage from "./pages/EngineeringPage";
import ContactPage from "./pages/ContactPage";

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminCameraModules from "./pages/admin/AdminCameraModules";
import AdminMDVR from "./pages/admin/AdminMDVR";
import AdminUltrasonic from "./pages/admin/AdminUltrasonic";
import AdminCaseStudies from "./pages/admin/AdminCaseStudies";
import AdminHeroBanners from "./pages/admin/AdminHeroBanners";
import AdminSubmissions from "./pages/admin/AdminSubmissions";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminPageContent from "./pages/admin/AdminPageContent";

// Public Layout wrapper
const PublicLayout = ({ children }) => (
  <>
    <Header />
    <main className="pt-20">{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <HelmetProvider>
      <GlobalProvider>
        <AuthProvider>
          <div className="App">
            <BrowserRouter>
              <ScrollToTop />
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
                <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
                <Route path="/mobility-imaging" element={<PublicLayout><MobilityImagingPage /></PublicLayout>} />
                <Route path="/surveillance" element={<PublicLayout><SurveillancePage /></PublicLayout>} />
                <Route path="/ultrasonic" element={<PublicLayout><UltrasonicPage /></PublicLayout>} />
                <Route path="/engineering" element={<PublicLayout><EngineeringPage /></PublicLayout>} />
                <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />

                {/* Admin Routes */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="page-content" element={<AdminPageContent />} />
                  <Route path="camera-modules" element={<AdminCameraModules />} />
                  <Route path="mdvr" element={<AdminMDVR />} />
                  <Route path="ultrasonic" element={<AdminUltrasonic />} />
                  <Route path="case-studies" element={<AdminCaseStudies />} />
                  <Route path="hero-banners" element={<AdminHeroBanners />} />
                  <Route path="submissions" element={<AdminSubmissions />} />
                  <Route path="settings" element={<AdminSettings />} />
                </Route>
              </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors />
          </div>
        </AuthProvider>
      </GlobalProvider>
    </HelmetProvider>
  );
}

export default App;
